import { Header } from "@/components/dash/Header";
import { Credit } from "@/components/dash/Credit";
import { ADMIN_ITEMS } from "./items";
import ManageAccess from "./ManageAccess";
import ResearchStudies from "./ResearchStudies";

const PAGES = { access: ManageAccess, research: ResearchStudies };

const SubNav = ({ current, onNav }) => (
  <aside className="adm-nav" data-testid="admin-subnav">
    <a className="adm-back" href="/" onClick={e => { e.preventDefault(); onNav("/"); }} data-testid="admin-back-btn">← Back to dashboard</a>
    <div className="kpi-label">Admin</div>
    <nav aria-label="Admin pages">
      {ADMIN_ITEMS.map(i => (
        <a key={i.id} href={i.path} aria-current={i.id === current.id ? "page" : undefined} onClick={e => { e.preventDefault(); onNav(i.path); }} data-testid={`admin-subnav-${i.id}`}>
          <b>{i.label}</b><span>{i.desc}</span>
        </a>
      ))}
    </nav>
  </aside>
);

export default function AdminLayout({ item, user, onLogout, onExpired, onNav }) {
  const Page = PAGES[item.id];
  return (
    <>
      <Header tab={null} onTab={t => onNav("/#" + t)} user={user} onLogout={onLogout} onNav={onNav} />
      <main className="wrap" id="main" data-testid="admin-layout">
        <div className="adm-shell">
          <SubNav current={item} onNav={onNav} />
          <section className="adm-content">
            <h2 className="adm-title" data-testid="admin-page-title">{item.label}</h2>
            <Page onExpired={onExpired} />
          </section>
        </div>
      </main>
      <Credit />
    </>
  );
}
